import React, { FC, useCallback, memo, useMemo } from 'react';
import _sortBy from 'lodash/sortBy';
import { useLazyQuery } from '@apollo/client';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import ErrorMessage from '@minecraft.error-message';
import { FilterData } from '../../../shared/types';
import { generateSelectOptionsBasedOnField } from '../../../shared/utils';
import { QUERY_PRESENTATIONS } from '../FilterBasicCollectionGraphQL';

type Props = {
  projectId: number;
  name: FilterData['name'];
  label: FilterData['label'];
};

const Presentations: FC<Props> = ({ projectId, name, label }) => {
  const [getPresentations, { data, loading, error }] = useLazyQuery(QUERY_PRESENTATIONS, {
    variables: {
      projectId,
    },
    fetchPolicy: 'cache-and-network',
  });

  const handlePresentationsFetch = useCallback((): void => {
    if (!data) {
      getPresentations();
    }
  }, [data]);

  const presentationsOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(_sortBy(data?.getPresentationsByProject, 'name'), 'name');
  }, [data?.getPresentationsByProject]);

  if (error) return <ErrorMessage error={error} />;

  return (
    <DropdownWithChildren
      withFormik
      withSearch
      withSelectAll
      isMultipleSelect
      isLoading={loading}
      name={name}
      toggleLabel={label}
      options={presentationsOptions}
      onOptionsFetch={handlePresentationsFetch}
    />
  );
};

export default memo(Presentations);
